import { render, staticRenderFns } from "./GjirafaIcons.vue?vue&type=template&id=b8086b0a"
import script from "./GjirafaIcons.vue?vue&type=script&lang=js"
export * from "./GjirafaIcons.vue?vue&type=script&lang=js"
import style0 from "./GjirafaIcons.vue?vue&type=style&index=0&id=b8086b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports